import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { StartPageComponent } from './start-page/start-page.component'
import { UserDetailsComponent } from './user-details/user-details.component'
import { MashkantaQuestionerComponent } from './mashkanta-questioner/mashkanta-questioner.component'
import { LoanDetailsComponent } from './loan-details/loan-details.component'
import { PropertyDetailsComponent } from './property-details/property-details.component'
import { BorrowersDetailsComponent } from './borrowers-details/borrowers-details.component';
import { FinancingSourcesComponent } from './financing-sources/financing-sources.component';
import { LiabilitiesComponent } from './liabilities/liabilities.component';
import { CanProceedGuard } from './can-proceed.guard';
import { SummarizePageComponent } from './summarize-page/summarize-page.component';
import { EndPageComponent } from './end-page/end-page.component';
import { AdvisorsComponent } from './advisors/advisors.component';
import { LoginComponent } from './login/login.component';



const routes: Routes = [
	{
		path: '',
		component: StartPageComponent,
		data: { title: 'טופס משכנתא' }
	},
	{
		path: 'login',
		component: LoginComponent,
	},

	{
		path: 'questionnaire',
		component: MashkantaQuestionerComponent,
		canActivateChild: [CanProceedGuard],

		children: [
			{
				path: 'advisors/:qid',
				component: AdvisorsComponent
			},
			{
				path: 'user-details/:qid',
				component: UserDetailsComponent
			},
			{
				path: 'loan-details/:qid',
				component: LoanDetailsComponent
			},
			{
				path: 'property-details/:qid',
				component: PropertyDetailsComponent
			},
			{
				path: 'borrowers-details/:qid',
				component: BorrowersDetailsComponent
			},
			{
				path: 'financing-sources/:qid',
				component: FinancingSourcesComponent
			},
			{
				path: 'liabilities/:qid',
				component: LiabilitiesComponent
			},
		]
	},

	{
		path: 'summarize',
		component: SummarizePageComponent
	},
	{
		path: 'end',
		component: EndPageComponent
	}

];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule]
})

export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts